import { CheckboxItemControl, FormCol, FormRow, P } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FormSection } from 'omni-package-react-core';
import { DocumentPreference } from '../../../../interfaces/DocumentPreference';
import DocumentPreferenceControl from './DocumentPreferenceControl/DocumentPreferenceControl';
import TextWithModalLink from '../../../../components/_TextWithModalLink';
import { StyledTexWrapper } from './DocumentPreferencesSection.styles';

export interface DocumentPreferencesSectionProps {
  preferences: DocumentPreference[];
  isSubscribedToDocumentNotification: boolean;
}

const DocumentPreferencesSection: FC<DocumentPreferencesSectionProps> = ({ preferences, isSubscribedToDocumentNotification }) => {
  const { t } = useTranslation('CommunicationPreferencesFormPage');
  const sortedPreferences = [...preferences].sort((x, y) => x.type.name.localeCompare(y.type.name));

  return (
    <FormSection title={t('documentPreferences.sectionTitle')}>
      <StyledTexWrapper>
        <TextWithModalLink
          translation="CommunicationPreferencesFormPage"
          sectionName="documentPreferences"
          modalName="availableDocumentsModal"
        />
      </StyledTexWrapper>
      {sortedPreferences.map((x) => <DocumentPreferenceControl key={x.type.id} preference={x} />)}
      <FormRow>
        <FormCol label={t('subscribeToDocumentNotification.label')} labelMarginBottom={28}>
          <CheckboxItemControl
            name="isSubscribedToDocumentNotification"
            defaultValue={isSubscribedToDocumentNotification}
            label={<P>{t('subscribeToDocumentNotification.text')}</P>}
          />
        </FormCol>
      </FormRow>
    </FormSection>
  );
};

export default DocumentPreferencesSection;
